<script lang="ts">
	import type { DocumentCategory } from "../../../core/schema/DocumentCategory.js";
	import { slugify } from "../../../core/utils/slugify.js";
	import { nbspify } from "../../../core/utils/nbspify.js";

	export let title: string;
	export let category: DocumentCategory;
</script>

<a
	href="#{slugify(category)}"
	class="group relative flex w-full max-w-[36.25rem] flex-col justify-end px-[3.75rem] py-3.5 sm:w-[36.25rem] lg:min-h-32"
>
	<span class="lg:text-2lg text-[1.75rem] font-bold">{nbspify(title)}</span>
	<div
		class="absolute inset-0 -z-10 bg-white backdrop-blur transition-colors duration-500 group-hover:bg-white/50"
	></div>
</a>
